import React, { lazy } from 'react';
import { Hand, Droplets, Smile } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: Hand,
    title: '1. Apply',
    desc: 'Apply a thin line of Dentafix™ gel along your clean denture. A little goes a long way for a perfect, secure fit.',
    color: 'bg-blue-100 text-blue-600',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&q=80',
    imageAlt: 'Applying dental product'
  }, {
    icon: Droplets,
    title: '2. Press',
    desc: 'Place the denture in your mouth and press firmly for 30 seconds. The gel activates on contact for an instant bond.',
    color: 'bg-cyan-100 text-cyan-600',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&q=80',
    imageAlt: 'Medical professional guidance'
  }, {
    icon: Smile,
    title: '3. Enjoy',
    desc: "That's it! Enjoy up to 3 full days of secure, comfortable hold. Eat, talk, and laugh with total confidence.",
    color: 'bg-green-100 text-green-600',
    image: 'https://images.unsplash.com/photo-1574279606130-09958dc756f7?w=600&q=80',
    imageAlt: 'Senior smiling with confidence'
  }];
  return <section className="py-16 md:py-24 bg-rose-50" data-id="element-207">
      <div className="container mx-auto px-4 md:px-6" data-id="element-208">
        <div className="text-center mb-16" data-id="element-209">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 font-serif" data-id="element-210">
            3 Simple Steps to All-Day Confidence
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-211">
            No more messy pastes. No more daily applications. Just simple,
            lasting comfort.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-212">
          {steps.map((step, index) => <div key={index} className="bg-white rounded-2xl shadow-lg border border-gray-100 relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-213">
              <div className="h-48 overflow-hidden" data-id="element-214">
                <img src={step.image} alt={step.imageAlt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-215" />
              </div>

              <div className="p-8 relative" data-id="element-216">
                <div className="absolute top-0 right-0 bg-gray-100 text-gray-400 font-bold text-6xl opacity-20 -mr-4 -mt-2 select-none" data-id="element-217">
                  {index + 1}
                </div>

                <div className={`${step.color} w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-sm`} data-id="element-218">
                  <step.icon className="w-8 h-8" data-id="element-219" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-220">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-221">{step.desc}</p>
              </div>
            </div>)}
        </div>

        {/* Bottom lifestyle banner */}
        <div className="mt-16 relative rounded-2xl overflow-hidden shadow-xl" data-id="element-222">
          <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=80" alt="Happy senior couple enjoying life together" className="w-full h-64 md:h-80 object-cover" loading="lazy" data-id="element-223" />
          <div className="absolute inset-0 bg-gradient-to-r from-red-900/70 to-transparent flex items-center" data-id="element-224">
            <div className="p-8 md:p-12 max-w-lg" data-id="element-225">
              <p className="text-white text-2xl md:text-3xl font-serif font-bold mb-2" data-id="element-226">
                "It's like getting a second chance at confidence."
              </p>
              <p className="text-white/80 text-lg" data-id="element-227">— Dentafix™ Customer</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}